module.exports = __webpack_public_path__ + "img/category_icon01@2x.7496dbad.png";